import { useEffect, useState } from "react";
import Input from "../Components/Input";
import axios from "axios";

export default function Payment({ cases }) {
    const [search, setSearch] = useState("");

    const found = cases.find(c => c.phone_number === search);
    function updatecase(phone_number) {
        axios.patch(`${process.env.REACT_APP_API_URL}/cases/paid`, { phone_number }).then((res) => {            
            alert("Case marked as paid!");
            window.location.reload();
        }).catch(err => {
            alert("Case cannot be marked as paid!");
            console.log(err.message)
        })
    }
    useEffect(()=>{
        document.querySelector(".payment-link").classList.toggle('on', true)
    },[])
    return (

        <div className="payment-page-wrapper">
            <section className="top-section">
                <h2>Payment Desk</h2>
                <input
                    placeholder="Enter Customer Phone Number"
                    className="custom-input"


                    onChange={e => setSearch(e.target.value)}

                />
            </section>
            {
                found ? 
                (<section className="card-container">
                    {found && (
                        <div className="card">
                            <p><span>Name: </span>{found.first_name} {found.last_name}</p>
                            <p><span>Modality: </span> {found.modality} {found.body}</p>
                            <p><span>Status: </span> {found.status}</p>
                            {
                                found.status === "AWAITING_PAYMENT" ? (
                                    <button onClick={() => updatecase(found.phone_number)}>
                                        Mark as Paid
                                    </button>
                                ) : (
                                    <button disabled>Paid</button>
                                )
                            }

                        </div>
                    )}
                </section>) : (<></>)
            }
        </div>

    );
}